module.exports = __webpack_public_path__ + "static_pc/img/cos02.2b7a38a5.png";